import { getAPI, putAPI } from "../../../api/Networking";
import { PermissionProject } from "../../../models/Employees/PermissionProject";
import {
  TeamPermissionActivityPage,
  TeamPermissionCatalog,
  TeamPermissionChange,
} from "../../../models/Employees/TeamPermission";

export default class TeamPermissionAPI {
  fetchCatalog = async (
    project: PermissionProject,
  ): Promise<TeamPermissionCatalog> => {
    try {
      const response = await getAPI("/v1/team-permissions", { project });
      return response.result as TeamPermissionCatalog;
    } catch (error) {
      throw error;
    }
  };

  saveChanges = async (
    project: PermissionProject,
    changes: TeamPermissionChange[],
  ): Promise<TeamPermissionCatalog> => {
    try {
      const response = await putAPI("/v1/team-permissions", {
        project,
        changes,
      });
      return response.result as TeamPermissionCatalog;
    } catch (error) {
      throw error;
    }
  };

  fetchActivityLogs = async (
    project: PermissionProject,
  ): Promise<TeamPermissionActivityPage> => {
    try {
      const response = await getAPI("/v1/team-permissions/activity-logs", {
        project,
        page_no: 1,
        limit: 50,
      });
      return response.result as TeamPermissionActivityPage;
    } catch (error) {
      throw error;
    }
  };
}
